module.exports = __webpack_public_path__ + "img/img_02.8cf4c9eb.webp";